<template>
  <div id="camera-container">
    <!--code v-if="device">Camera: {{ device.label }}</code-->
    <VueWebCam
      ref="webcam"
      :device-id="deviceId"
      width="100%"
      height="100%"
      @started="onStarted"
      @stopped="onStopped"
      @error="onError"
      @cameras="onCameras"
      @camera-change="ChangeCamera"
    />
    <div v-if="cameraStarted">
      <br>
      <!--div class="col-md-12">
        <v-select v-model="camera"
                  :items="devices"
                  item-value="deviceId"
                  item-text="label"/>
      </div-->

      <br>
      <v-btn
        v-if="webcamPresent"
        id="camera-capture"
        color="primary"
        @click="CaptureImage()"
      >
        <v-icon>mdi-camera</v-icon>
      </v-btn>

      <v-btn
        v-if="devices.length > 1"
        id="camera-switch"
        color="primary"
        @click="SwitchCamera()"
      >
        <v-icon>mdi-cached</v-icon>
      </v-btn>
    </div>
    <h3
      v-else
      class="camera-placeholder"
    >
      {{ $t('signature.sign.advanced.photo.waiting_camera') }}
    </h3>
    <!--v-btn color="secondary" @click="StartWebcam()">Start</v-btn>
    <v-btn color="secondary" @click="StopWebcam()">Stop</v-btn-->

    <!--br>
    <div class="col-md-6">
      <h2>Captured Image</h2>
      <figure class="figure">
        <img :src="img" class="img-responsive" />
      </figure>
    </div-->
    <div
      v-if="cameraStarted && !webcamPresent"
      id="qrcode-container"
    >
      <h2>Fotocamera non rilevata</h2>
      <p>Inquadra il QR Code con la fotocamera del tuo smartphone</p>
      <QrcodeVue :value="qrcodeUrl" />
    </div>
  </div>
</template>

<script>
import { WebCam } from 'vue-web-cam'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'WebCam',

  components: {
    VueWebCam: WebCam,
    QrcodeVue,
  },

  props: {
    qrcodeUrl: {
      type: String,
      default: null,
    },
  },

  data () {
    return {
      // img: null,
      camera: null,
      deviceId: null,
      devices: [],
      deviceIndex: 0,
      cameraStarted: null,
    }
  },

  computed: {
    device () {
      return this.devices.find(device => device.deviceId === this.deviceId)
    },
    // deviceItems() {
    //   return this.devices.map(d => d.deviceId)
    // }
    webcamPresent () {
      return this.devices.length > 0
    },
  },

  created () {
    // this.$refs.webcam.start()
  },

  methods: {
    SwitchCamera () {
      this.deviceIndex += 1
      if (this.deviceIndex > (this.devices.length - 1)) {
        this.deviceIndex = 0
      }
      this.ChangeCamera(this.devices[this.deviceIndex].deviceId)
    },
    CaptureImage () {
      // this.img = this.$refs.webcam.capture()
      const img = this.$refs.webcam.capture()
      this.$emit('capture', img)
    },
    onStarted (stream) {
      //console.log('On Started Event', stream)
      setTimeout(() => { this.cameraStarted = true }, 1000)
    },
    onStopped (stream) {
      //console.log('On Stopped Event', stream)
    },
    // StopWebcam() {
    //   this.$refs.webcam.stop();
    // },
    // StartWebcam() {
    //   this.$refs.webcam.start();
    // },
    onError (error) {
      //console.log('On Error Event', error)
    },
    onCameras (cameras) {
      this.devices = cameras
      //console.log('On Cameras Event', cameras)
      if (!this.camera) {
        if (this.devices[0]) {
          this.ChangeCamera(this.devices[0].deviceId)
        } else {
          //console.log('No camera detected')
          this.$emit('error', 'no-camera')
        }
      }
    },
    ChangeCamera (deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
      //console.log('On Camera Change Event', deviceId)
    },
  },

  // watch: {
  //   camera: function(id) {
  //     this.deviceId = id;
  //   },
  //   devices: function() {
  //     // Once we have a list select the first one
  //     const [first, ...tail] = this.devices;
  //     if (first) {
  //       this.camera = first.deviceId;
  //       this.deviceId = first.deviceId;
  //     }
  //   }
  // },
}
</script>

<style lang="scss" scoped>
  #camera-container {
    position: relative;
    display: flex;
  }

  #camera-capture {
    position: absolute;
    top: 4%;
    left: 4%;
    z-index: 3;
  }

  #camera-switch {
    position: absolute;
    top: 4%;
    right: 4%;
    z-index: 3;
  }

  video {
    z-index: 2;
  }

  .camera-placeholder {
    display: grid;
    place-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    color: gray;
    z-index: 1;
  }

  #qrcode-container {
    display: grid;
    place-items: center;
    color: gray;
    padding: 1rem;
  }

</style>
